$(function () {
  $('body').on('click', '.navbar .menu-item-has-children > a:not(.menu-item-has-children li > a)', function (e) {
    e.preventDefault();
    $('body').removeClass('search-active');
    $('.header input#search').val('');
    if ($(this).hasClass('active')) {
      $('body').removeClass('sub-menu-active');
      $('.navbar .menu-item-has-children > a').removeClass('active');
      $('.navbar .sub-menu').removeClass('active');
      $('.overlay').fadeOut();
    } else {
      $('.navbar .menu-item-has-children > a').removeClass('active');
      $('.navbar .sub-menu').removeClass('active');
      $(this).addClass('active');
      $('body').addClass('sub-menu-active');
      $(this).parent().find('.sub-menu').addClass('active');
      $('.overlay').fadeIn();
    }
  });

  $('body').on('click', '.overlay', function (e) {
    e.preventDefault();
    $('body').removeClass('sub-menu-active');
    $('.navbar .menu-item-has-children > a').removeClass('active');
    $('.navbar .sub-menu').removeClass('active');
    $('body').removeClass('search-active');
    $('.header input#search').val('');
    $(this).fadeOut();
  });

  // Sub nav
  $('body').on('click', '.slidenav .menu-item-has-children > a:not(.menu-item-has-children li > a)', function (e) {
    e.preventDefault();
    var navlabel = $(this).find('span').text();
    $(this).siblings('ul.sub-menu').find('.back-arrow').text(navlabel);
    $(this).siblings('ul.sub-menu').addClass('active');
    $('.mobile-navigation .button').hide();
  });
  $('.slidenav ul.sub-menu .back-arrow').click(function () {
    $(this).closest('ul.sub-menu').removeClass('active');
    $('.mobile-navigation .button').show();
  });

  // Search Box
  $('html').on('click', '.search-box', function (event) {
    event.preventDefault();
    $('body').removeClass('sub-menu-active');
    $('.navbar .menu-item-has-children > a').removeClass('active');
    $('.navbar .sub-menu').removeClass('active');
    if ($(this).hasClass('active')) {
      $('body').removeClass('search-active');
      $('.header input#search').val('');
    } else {
      $('body').addClass('search-active');
    }
  });

  // Close search
  $(document).bind("mouseup touchend", function (e) {
    if ($('body').hasClass('search-active')) {
      $('body').removeClass('search-active');
      $('.header input#search').val('');
    }
  });

  // Hamburger
  $('.hamburger').on('click', function () {
    $('body').toggleClass('nav-active');

    if ($(this).attr('aria-expanded') == 'false') {
      $(this).attr('aria-expanded', 'true');
      $(this).addClass('is-active');
    } else {
      $(this).attr('aria-expanded', 'false');
      $(this).removeClass('is-active');
    }
  });

  // Adds a label to second depth menus
  function subMenuLabels() {
    $('.nav-mobile-wrapper .menu-item-has-children').each(function () {
      let parentTxt = $(this).find('> a span').text();
      $(this).find('.sub-menu').prepend('<span>' + parentTxt + '</span>');
    });
  }
  subMenuLabels();

  // Allows clicking the menu label to go back
  $('.sub-menu > span').on('click', function () {
    $(this).parent().removeClass('active');
  });

  // Disables clickthroughs on links with children, instead enables the second level nav
  $('#menu-main-menu-2 .menu-item-has-children > a').on('click', function (e) {
    e.preventDefault();

    $('#menu-main-menu-2 .menu-item-has-children').find('.sub-menu').removeClass('active').slideUp(100);
    $(this).parent().find('.sub-menu').addClass('active').slideDown(100);
  });

});